import "../index.css";
import { PencilIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Card, Heading, IconButton, LabelValue, Row, Tooltip } from "@/ui-kit";

type IProps = {
  expertise: string[];
  yearsOfExperience: number;
  onEdit?: () => void;
};

export const ExperienceCard = ({
  expertise,
  yearsOfExperience,
  onEdit,
}: IProps) => {
  const { t } = useTranslation();
  const labelWidth = "80px";

  return (
    <Card className="profile-card">
      <Card.Body>
        <Row gap="xl" alignmentVertical="top">
          <div className="profile-card__details">
            <Row gap="sm">
              <Heading level={3} tone="default">
                {t("label.experience")}
              </Heading>

              {onEdit && (
                <div className="profile-card__actions">
                  <Tooltip content={t("action.edit")} placement="bottom-end">
                    <IconButton
                      size="sm"
                      variant="ghost"
                      color="neutral"
                      content={<PencilIcon />}
                      onClick={onEdit}
                      aria-label={t("action.edit")}
                    />
                  </Tooltip>
                </div>
              )}
            </Row>

            <div className="profile-card__sections">
              <div className="profile-card__section">
                <LabelValue
                  label={t("label.expertise")}
                  value={
                    expertise.length > 1 ? expertise.join(", ") : expertise[0]
                  }
                  labelWidth={labelWidth}
                />
                <LabelValue
                  label={t("label.experience")}
                  value={t("label.n_years", { count: yearsOfExperience })}
                  labelWidth={labelWidth}
                />
              </div>
            </div>
          </div>
        </Row>
      </Card.Body>
    </Card>
  );
};
